import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>DELETE /users/me/cm/subscriptions</h1>
        </div>
        <p>
          Remove the current user and device as a subscriber of{" "}
          <em>Cloud Message (CM)</em>. The will prevent the user from receiving
          push notifications on the device.
        </p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>subscriptionId</td>
                <td>
                  Unique identifier of the subscription (response from{" "}
                  <Link to="/api/users_me_cm_subscriptions__post">
                    POST /users/me/cm/subscriptions
                  </Link>
                  ).
                </td>
                <td>query</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>deviceId</td>
                <td>
                  Unique identifier of the device (response from{" "}
                  <Link to="/api/users_me_cm_subscriptions__post">
                    POST /users/me/cm/subscriptions
                  </Link>
                  ).
                </td>
                <td>query</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          DELETE
          https://spacesapis.avayacloud.com/api/users/cm/subscriptions?subscriptionId=12344444444&amp;deviceId=d2f9e527-c119-4ee5-c275-d5146f43240b
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
{`{
    "deviceId": "d6d843bf3-ab98-49f5-9d34-23b4822bf05a",
    "dataOnly": false,
    "type": "firebase",
    "scope": [],
    "_id": "5f203973c5a013266da8c5a4",
    "__v": 0,
    "status": "removing",
    "created": "2020-07-28T14:42:59.911Z",
    "id": "5f203973c5a013266da8c5a4"
}`}
        </pre>
      </div>
    </div>
  </Layout>
)
